export default __webpack_public_path__ + "static/media/speaker.b36a6b3a.png";